import { render, staticRenderFns } from "./SnookerOrderRecord.vue?vue&type=template&id=454b1715&"
import script from "./SnookerOrderRecord.vue?vue&type=script&lang=js&"
export * from "./SnookerOrderRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports